import { Link } from 'react-router-dom';
import { PageHeader, Hero } from '../components/PageComponents';
import './Products.css';

const products = [
  {
    id: 'robohound',
    name: 'Robohound AI Hub',
    description: 'A comprehensive AI ecosystem specializing in intelligent searching, indexing, analytics, and security to power the next generation of data-driven enterprises.',
    icon: '/Content/icons/robohound/robohound-64x64.png',
    link: 'https://robohound.ai',
    external: true,
    badge: 'AI Innovation',
    badgeColor: 'purple',
    featured: false
  },
  {
    id: 'intellimatcher',
    name: 'IntelliMatcher',
    description: 'AI-Based RFQ evaluation and Generator tool designed to streamline procurement with intelligent matching.',
    icon: '/Content/icons/intellimatcher/intellimatcher.svg',
    link: 'https://intellimatcher.robohound.ai',
    external: true,
    badge: 'AI-Powered',
    badgeColor: 'purple',
    featured: false
  },
  {
    id: 'medibotx',
    name: 'Medibotx',
    description: 'Next generation clinic management system, powered by AI. Transform your healthcare operations with intelligent automation, seamless patient engagement, and comprehensive management tools designed for modern clinics.',
    icon: '/Content/icons/medibotx/Medibotx-64x64.png',
    link: 'https://www.medibotx.com',
    external: true,
    badge: 'AI-Powered',
    badgeColor: 'blue'
  },
  {
    id: 'analytics',
    name: 'Smart Performance Analytics',
    description: 'Streamline your planning and reporting processes with Smart Performance Analytics to make intelligent decisions faster. Generate visually compelling dashboards with data extracted from your on-premise databases.',
    icon: '/Content/icons/SmartPerformanceAnalytics/analytics-64x64.png',
    link: 'https://smartperformanceanalytics.smart-wares.com/',
    external: true,
  },
  {
    id: 'case-management',
    name: 'Smart Case Management',
    description: 'A web based solution that provides a one-stop integrated solution for managing customer generated feedback, enquiries, suggestion, complaints and investigative cases.',
    icon: '/Content/icons/casemgmt/Customer-Services-64x64.png',
    link: '/products/case-management',
    external: false,
    featured: false
  },
  {
    id: '247shift',
    name: '247Shift.com',
    description: 'Cloud based staff scheduling and rostering application. Available via subscription.',
    icon: '/Content/icons/clock/clock-time-7-64x64.png',
    link: 'https://www.247shift.com',
    external: true,
  }
];

function Products() {
  return (
    <>
      <Hero 
        imageSrc="/Images/PI-ID463024.jpg"
        imageAlt="Enterprise Products"
        title="Products"
        subtitle="Our SMART-Solutions"
        imagePosition="center 25%"
      />

      <div className="container">
        <section className="section section-sm">
          <div className="products-catalog-grid">
          {products.map((product) => (
            <div key={product.id} className={`product-card ${product.featured ? 'product-featured' : ''}`}>
              <div className="product-icon-container">
                <img 
                  src={product.icon} 
                  alt={product.name}
                  width="256"
                  height="256"
                />
              </div>
              
              <div className="product-content">
                <div className="product-header">
                  <h3>{product.name}</h3>
                  <span className={`badge badge-${product.badgeColor}`}>{product.badge}</span>
                </div>
                <p>{product.description}</p>
                
                <div className="product-actions">
                  {product.external ? (
                    <a 
                      href={product.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="button button-secondary button-small"
                    >
                      Visit Site ↗
                    </a>
                  ) : (
                    <Link 
                      to={product.link}
                      className="button button-secondary button-small"
                    >
                      Learn More →
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  </>
  );
}

export default Products;
